
import { ReminderEmailTemplate } from "@/models/reminder-email-template";
import { ReminderService } from "@/services/reminder-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		emailTemplates: {
			type: Array as () => ReminderEmailTemplate[],
			required: true
		}
	},
	methods: {
		newEmailTemplate() {
			this.$router.push("/settings/reminder-email-template/new");
		},
		editEmailTemplate(template:ReminderEmailTemplate) {
			this.$router.push(`/settings/reminder-email-template/${template.ID}`);
		},
		async deleteEmailTemplate(template:ReminderEmailTemplate) {
			let confirm = await this.$wf.confirm(this.$ct("confirm-delete-template"), this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
			if (!confirm) {
				return;
			}
			await ReminderService.deleteEmailTemplates([template]);
			this.$emit("update-email-templates");
		}

	},
	components: {
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
